import Button from "components/Form/fields/Button";
import { getIconForUID } from "components/FormerEditor/utils";
import IconButtonBar from "components/IconButtonBar";
import React from "react";
import { AUTO_ATTRS } from "components/Form/fields/constants";
import { LIST_PRESENTATION_CONFIG } from "utils/constants/ui";

const DEFAULT_CLASSES = {
  inputWrapper: "flex flex-row items-center w-100 pr2 pl2-ns",
  input:
    "f5 f6-ns border-box input-reset ba pa2 db w-100 br2 lh-copy b--black-20"
};

const DEFAULT_PRESENTATION = {
  config: LIST_PRESENTATION_CONFIG
};

const IndexActionBar = ({
  hidePresentationToggle,
  presentation = DEFAULT_PRESENTATION,
  search,
  actions,
  customClasses,
  setValues,
  values
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const SearchIcon = getIconForUID("search");

  const setPresentation = (updatedPresentation) => {
    const updatedValues = { ...values };
    updatedValues.presentation = updatedPresentation;
    setValues(updatedValues);
  };

  const onSearch = (evt) => {
    const updatedValues = { ...values };
    updatedValues.search = evt.currentTarget.value;
    setValues(updatedValues);
  };

  const inputProps = {
    className: classes.input,
    type: "text",
    name: "text",
    ...AUTO_ATTRS,
    ...search,
    value: values.search,
    onChange: onSearch
  };

  return (
    <div className="flex justify-end items-center">
      {!hidePresentationToggle && (
        <div className="h-100 pr2 br hairline-1 dn flex-ns flex-row">
          <IconButtonBar
            value={values.presentation}
            config={presentation.config}
            onClick={setPresentation}
          />
        </div>
      )}
      <div className={classes.inputWrapper}>
        <SearchIcon size={16} />
        <div className="pl2 w-100">
          <input {...inputProps} />
        </div>
      </div>
      {actions &&
        actions.map((action, actionIx) => (
          <Button key={actionIx} {...action} />
        ))}
    </div>
  );
};

export default IndexActionBar;
